import SquareSVG from '../../src/pages/dashboard/homePage/ImageResizerPopUp/Square.svg';
import PortraitSVG from '../../src/pages/dashboard/homePage/ImageResizerPopUp/Portrait.svg';
import LandscapeSVG from '../../src/pages/dashboard/homePage/ImageResizerPopUp/Landscape.svg';

export const list = [{
    height: 2560,
    width: 2560,
    icon: SquareSVG
},{
    height: 2560,
    width: 1440,
    icon: PortraitSVG
},{
    height: 1440,
    width: 2560,
    icon: LandscapeSVG
}]